import React from 'react';
const styles = {
    ok: {
        color: 'green',
    },
    warning: {
        color: 'red',
    },
};

export default function UserStatusBoolean(props) {
    const status = props.status;

    return (
        <React.Fragment>
            {status.enabled && <span style={styles.ok}>Aktiivinen</span>}
            {!status.enabled && <span style={styles.warning}>Disabloitu</span>}
            &nbsp;
            {status.amazonStatus && <span>({status.amazonStatus})</span>}
        </React.Fragment>
    );
}
